import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DatePicker from "react-datepicker";
import {
  Delete,
  Visibility,
  Download,
  PagesRounded,
  ShieldMoon,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/timeline.css";

function PostChallan(props) {
  const [piData, setPiData] = useState([]);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);
  const [logisticData, setLogisticData] = useState({});
  const [shipments, setShipments] = useState([]);

  const dispatch = useDispatch();
  const fields = [
    { label: "Delivery Note No.", key: "deliverynoteno" },
    { label: "Dated", key: "delivery_note_date" },
    { label: "", key: "" },
    { label: "Mode/Terms of Payment", key: "payment_terms" },
    { label: "Reference No. & Date.", key: "ref_no_date" },
    { label: "Other References", key: "other_ref" },
    { label: "Buyer’s Order No.", key: "buyers_order_no" },
    { label: "Dated", key: "buyers_order_date" },
    { label: "Dispatch Doc No.", key: "dispacth_doc_no" },
    { label: "", key: "" },
    { label: "Dispatched through", key: "dispatched_through" },
    { label: "Destination", key: "destination" },
    { label: "Bill of Lading/LR-RR No.", key: "bill_of_landing_lr_rr_no" },

    { label: "Motor Vehicle No.", key: "motor_vehicle_no" },
  ];

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getLogisticData();
  }, []);

  const getLogisticData = () => {
    const orderId =
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id;
    utils
      .callAPI("get", `/sales/getlogisticDataList?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          // console.log(res);
          setLogisticData(res);
          setPiData(res?.pi_response);

          const shipments = [];
          res.shipment.map((shipment) => {
            const logisticData = res?.logisticdata ?? [];
            const logisticItems = [];
            let totalShipmentQty = 0;
            if (logisticData) {
              logisticData
                .filter(
                  (l) => parseInt(l.shipment_id) === parseInt(shipment.id)
                )
                .map((product) => {
                  const productData = shipment.items.find(
                    (p) =>
                      parseInt(p.item_name) === parseInt(product.product_id)
                  );

                  totalShipmentQty += parseInt(product?.no_of_bags ?? 0);

                  logisticItems.push({
                    productId: product.product_id,
                    productName: productData?.product_name,
                    batchNo: product?.batch_no,
                    mfg: product?.mfg,
                    noBags: product?.no_of_bags ?? 0,
                    qty: productData?.item_qty,
                    remarks: product?.remarks,
                    location: product?.office_location_id,
                  });
                });
            }

            const shipmentData = {
              shipmentId: shipment.id,
              shipmentName: shipment.shipment_name,
              address: shipment.address,
              addressType: shipment.address_type,
              shipmentMethod: shipment.shipment_method,
              godownId: shipment.godown_id,
              godownName: shipment.godown_name,
              items: logisticItems,
              totalShipmentQty: totalShipmentQty,
            };
            shipments.push(shipmentData);
          });
          // console.log(shipments)
          setShipments(shipments);
        } else {
          setLogisticData({});
          setPiData([]);
        }
      })
      .catch((err) => {
        setLogisticData({});
        setPiData([]);
      });
  };

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleDownload = (shipmentId) => {
    let apiUrl = "";
    if (shipmentId > 0) {
      apiUrl = `/sales/download_post_challan_by_shipment/${piData?.id}/${shipmentId}`;
    } else {
      apiUrl = `/sales/download_post_challan/${piData?.id}`;
    }

    utils
      .callAPI("get", apiUrl)
      .then((res) => {
        if (typeof res !== "undefined") {
          const a = document.createElement("a");
          a.href = res;
          a.target = "_blank"; // or "_self" depending on your preference
          a.rel = "noopener noreferrer";
          a.click();
        } else {
          //setPiData([]);
        }
      })
      .catch((err) => {
        // setPiData([]);
      });
  };

  return (
    <div className="section-body">
      <RB.Card className="card ">
        <RB.Card.Header className="border-0">
          <h4>Delivery Note - Post Challan</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-light me-2"
              onClick={() => handleDownload(0)}
            >
              Download
            </RB.Button>
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>

        <RB.Card.Body className="p-2 p-md-3">
          <div className="border">
            <RB.Row className="g-0">
              <RB.Col md={7} className="border-end">
                <div className="ms-2 border-bottom">
                  <strong>
                    {" "}
                    {logisticData?.locationdata?.name}{" "}
                    {`(${logisticData?.locationdata?.city})`}
                  </strong>
                  <br />
                  {logisticData?.locationdata?.address}
                  <br />
                  {logisticData?.locationdata?.state} -{" "}
                  {logisticData?.locationdata?.pincode} <br />
                  GSTIN/UIN: {logisticData?.locationdata?.gst_uni} <br />
                  State Name: {logisticData?.locationdata?.state}, Code : 08{" "}
                  <br />
                  E-Mail : {logisticData?.locationdata?.contact_person_email}
                </div>
                {/* <hr className="m-0 p-0" /> */}
                <div className="mt-1 ms-2 border-bottom">
                  <span>Consignee (Ship to)</span>
                  <br />
                  <strong>{logisticData?.channel_details?.companyName}</strong>
                  <br />
                  {logisticData?.channel_details?.company_address},{" "}
                  {logisticData?.channel_details?.company_city}
                  <br />
                  {logisticData?.channel_details?.company_state} -{" "}
                  {logisticData?.channel_details?.company_pincode} <br />
                  GSTIN/UIN: {logisticData?.channel_details?.gst_no} <br />
                  State Name: {logisticData?.channel_details?.company_state},
                  Code : 08 <br />
                </div>
                {/* <hr className="m-0 p-0" /> */}
                <div className="mt-1 ms-2">
                  <span>Buyer (Bill to)</span>
                  <br />
                  <strong>{logisticData?.channel_details?.companyName}</strong>
                  <br />
                  {logisticData?.channel_details?.company_address},{" "}
                  {logisticData?.channel_details?.company_city}
                  <br />
                  {logisticData?.channel_details?.company_state} -{" "}
                  {logisticData?.channel_details?.company_pincode} <br />
                  GSTIN/UIN: {logisticData?.channel_details?.gst_no} <br />
                  State Name: {logisticData?.channel_details?.company_state},
                  Code : 08 <br />
                </div>
              </RB.Col>

              <RB.Col md={5}>
                <RB.Row className="g-0 row-devided-2">
                  {/*{fields.slice(0, 6).map((field, index) => (*/}
                  {fields.map((field, index) => (
                    <>
                      <div
                        key={index}
                        className={`col-6 ps-1 border-bottom ${
                          isSmallScreen ? "invoice-border" : ""
                        }`}
                      >
                        <span className="text-uppercase fw-bold small text-body-secondary ps-1">
                          {field.label}
                        </span>
                        <p className="fw-medium text-sm fw-semibold ps-1">
                          {field.label === "Dated" ||
                          field.label === "Delivery Note Date"
                            ? moment(piData?.[field.key]).format("DD-MMM-YYYY")
                            : piData?.[field.key] || " "}
                        </p>
                      </div>
                      {/* <hr className="m-0 p-0" /> */}
                    </>
                  ))}
                </RB.Row>

                <div className="">
                  <div>
                    <div
                      className={`${isSmallScreen ? "invoice-border" : "ps-2"}`}
                    >
                      <span className="text-uppercase fw-bold small text-body-secondary ">
                        Terms of Delivery
                      </span>
                      <p
                        className="fw-medium text-sm fw-semibold"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        <ul>
                          {piData?.delivery_terms
                            ? piData?.delivery_terms
                                .split("\n")
                                .map(function (item, idx) {
                                  return <li key={idx}>{item}</li>;
                                })
                            : " "}
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </RB.Col>
            </RB.Row>
          </div>

          {shipments &&
            shipments.map((shipment) => (
              <RB.Card
                className={"rounded-0 mb-0 border-top-0 border-bottom-0"}
              >
                <RB.CardHeader className="justify-content-between align-items-center">
                  <h5 className={"mb-0"}>{shipment?.shipmentName}</h5>
                  <RB.Button
                    onClick={() => handleDownload(shipment?.shipmentId)}
                    className="btn-primary"
                  >
                    Download
                  </RB.Button>
                </RB.CardHeader>
                <RB.CardHeader>
                  <RB.Row className="w-100">
                    <RB.Col md={1} sm={2}>
                      <span className="text-uppercase fw-bold small text-body-secondary ">
                        Type
                      </span>
                      <p className="fw-medium text-sm fw-semibold mb-0">
                        {shipment?.addressType}
                      </p>
                    </RB.Col>
                    {shipment.godownId !== "0" && (
                      <RB.Col md={3} sm={5}>
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Godown
                        </span>
                        <p className="fw-medium text-sm fw-semibold mb-0">
                          {shipment.godownName}
                        </p>
                      </RB.Col>
                    )}
                    <RB.Col md={3} sm={5}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Shipping Method
                      </span>
                      <p className="fw-medium text-sm fw-semibold mb-0">
                        {shipment?.shipmentMethod}
                      </p>
                    </RB.Col>
                    <RB.Col md={true}>
                      <span className="text-uppercase fw-bold small text-body-secondary">
                        Shipping Address
                      </span>
                      <p className="fw-medium text-sm fw-semibold mb-0">
                        {shipment?.address}
                      </p>
                    </RB.Col>
                  </RB.Row>
                </RB.CardHeader>
                <RB.Table
                  responsive
                  bordered
                  hover
                  striped
                  className="invoice-table border mb-0 table-sm"
                >
                  <thead>
                    <tr>
                      <th className="text-center">Sr. No.</th>
                      <th>Description of goods</th>
                      <th className="text-center">Batch No.</th>
                      <th className="text-center">Mfg.</th>
                      <th className="text-center">Quantity</th>
                      <th className="text-center">Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shipment.items?.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        {/* Sr No. starts from 1 */}
                        <td>{product?.productName}</td>
                        <td className={"text-center"}>{product?.batchNo}</td>
                        <td>{product?.mfg}</td>
                        <td className="text-center">{product?.noBags}</td>
                        <td>{product?.remarks}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th></th>
                      <th colSpan={3} className="text-end">
                        Total
                      </th>
                      <th className="text-center">
                        {`${shipment.totalShipmentQty} Bags` || " "}
                      </th>
                      <th></th>
                    </tr>
                  </tfoot>
                </RB.Table>
              </RB.Card>
            ))}

          <div className="border mb-3">
            <RB.Row className="justify-content-between ms-1 me-1 mb-5 pb-5">
              <RB.Col className="text-end">
                <span>E. & O.E</span>
              </RB.Col>
            </RB.Row>

            <RB.Row className="ms-1 me-1 mt-3 row-cols-1 row-cols-sm-2 ">
              <RB.Col className="border-top border-end-sm">
                {" "}
                <span className="mt-1"> Recd. in Good Condition </span>
                <br />
              </RB.Col>

              <RB.Col className="border-top mt-2 mt-sm-0 ">
                <div className="text-end">
                  <strong>
                    for {logisticData?.locationdata?.name}{" "}
                    {`(${logisticData?.locationdata?.city})`}
                  </strong>
                  <br />
                  <br />
                  <span className="">Authorised Signatory</span>
                </div>
              </RB.Col>
            </RB.Row>
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default PostChallan;
